module.exports = __webpack_public_path__ + "static/media/dyer_pusins.06cb502b.jpg";